module.exports = __webpack_public_path__ + "img/pierre_n.a97c742e.png";